import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  MenuItem,
  Box,
  IconButton,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import axiosInstance from "../../../axiosConfig/instance";
import { create, updateprofile } from "../../../components/Apis";

const EditProfile = ({ editForm, profile, getProfile }) => {
  console.log(profile)
  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [identityTypes, setIdentityTypes] = useState([]);
  const [otp, setotp] = useState("");
  const [verifyform, setverifyform] = useState(false);
  const [previewImage, setPreviewImage] = useState(null); // حالة لمعرفة الصورة المرفوعة

  console.log(identityTypes)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    address: "",
    cityId: "",
    countryId: "",
    identityTypeId: "",

  });

  const [Files, setFiles] = useState({

    identityImages: [],
    profileImage: null,
  }); console.log(Files)

  useEffect(() => {
    if (profile) {
      // تحديث بيانات formData
      setFormData({
        firstName: profile.first_name || "",
        lastName: profile.last_name || "",
        email: profile.email || "",
        phoneNumber: profile.phone_number || "",
        address: profile.address || "",
        cityId: profile.city || "",
        countryId: profile.country || "",
        identityTypeId: profile.identity_type || "",
      });

      // تحديث بيانات Files


      // إعداد معاينة الصورة
      if (profile.image) {
        setPreviewImage(profile.image);
      }
    }
  }, [profile]);
  console.log(Files)

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        // استدعاء APIs بشكل متزامن
        const [citiesRes, countriesRes, identityTypesRes] = await Promise.all([
            axiosInstance.get("/v1/cities"), // استبدل بـ URL الصحيح
            axiosInstance.get("/v1/countries"), // استبدل بـ URL الصحيح
            axiosInstance.get("/v1/identity-types"), // استبدل بـ URL الصحيح
        ]);

        // تعيين البيانات في الحالات
        setCities(citiesRes.data.data);
        setCountries(countriesRes.data.data);
        setIdentityTypes(identityTypesRes.data.data);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }

      // try {
      //   // First, let's test each endpoint separately
      //   console.log('Starting API calls...');

      //   try {
      //     const citiesRes = await axiosInstance.get("/v1/cities");
      //     console.log('Cities data:', citiesRes.data);
      //     if (citiesRes.data?.data) setCities(citiesRes.data.data);
      //   } catch (error) {
      //     console.error("Cities API error:", error.response || error);
      //   }

      //   try {
      //     const countriesRes = await axiosInstance.get("/v1/countries");
      //     console.log('Countries data:', countriesRes.data);
      //     if (countriesRes.data?.data) setCountries(countriesRes.data.data);
      //   } catch (error) {
      //     console.error("Countries API error:", error.response || error);
      //   }

      //   try {
      //     const identityTypesRes = await axiosInstance.get("/v1/identity-types");
      //     console.log('Identity Types data:', identityTypesRes.data);
      //     if (identityTypesRes.data?.data) setIdentityTypes(identityTypesRes.data.data);
      //   } catch (error) {
      //     console.error("Identity Types API error:", error.response || error);
      //   }

      // } catch (error) {
      //   console.error("General error:", {
      //     message: error.message,
      //     response: error.response?.data,
      //     status: error.response?.status,
      //     fullError: error
      //   });

      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Error',
      //     text: `Failed to load data: ${error.response?.data?.message || error.message}`,
      //   });
      // }
    };

    fetchDropdownData();
  }, []);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "identityImages") {
      setFiles((prevData) => ({
        ...prevData,
        [name]: [...prevData[name], ...Array.from(files)], // إضافة الصور الجديدة إلى القائمة الحالية
      }));
    } else if (name === "profileImage") {
      const file = files[0];
      setFiles((prevData) => ({
        ...prevData,
        [name]: file,
      }));
      // عرض معاينة الصورة
      const reader = new FileReader();
      reader.onload = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData(); // التصحيح: استخدام اسم متغير صحيح بدلاً من إعادة تعريفه

    // إضافة كل قيمة إلى FormData بشكل منفصل
    data.append("first_name", formData.firstName);
    data.append("last_name", formData.lastName);
    data.append("email", formData.email);
    data.append("phone_number", formData.phoneNumber);
    data.append("address", formData.address);
    data.append("city_id", formData.cityId);
    data.append("country_id", formData.countryId);
    data.append("identity_type_id", formData.identityTypeId);
    if (Files.identityImages) {
      Files.identityImages.forEach((img) => {
        data.append("identity_images[]", img); // التصحيح: استخدام formData.identityImages بدلاً من Files.identityImages
      });
    }

    // إضافة صورة الملف الشخصي إذا كانت موجودة
    if (Files.profileImage) {
      data.append("image", Files.profileImage); // التصحيح: استخدام formData.profileImage بدلاً من Files.profileImage
    }

    // عرض محتويات FormData في الكونسول
    for (let [key, value] of data.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      Swal.showLoading();
      // إرسال البي
      // swانات إلى الـ API
      const res = await updateprofile(data); // التصحيح: تأكد من وجود دالة create
      Swal.close();

      console.log(res);

      // التحقق من الاستجابة
      if (res.success) {
        // تنفيذ أي إجراء عند النجاح
        Swal.fire("Account Edit successfully")
        getProfile()
        editForm(false)
        //  const ress = await create(res.data.data.otp); // التصحيح: تأكد من وجود دالة create
        //  console.log(ress)

      } else if (res.message === "Request failed with status code 413") {
        console.error("Please upload a smaller image or PDF file.");
      } else if (res.response?.data?.success === false) {
        Swal.fire({
          icon: "error", // لتحديد رمز الخطأ
          title: "Error",
          text: res.response.data.message || "An error occurred.",
          confirmButtonText: "OK",
        });

      } else {
        console.error("An unexpected error occurred:", res.message);
      }
    } catch (error) {
      console.error("Error creating account:", error.message);
    }
    finally {

    }
  };

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: "auto" }} dir={"ltr"}>
      <Box
        sx={{
          padding: '10px 20px',
          textAlign: 'right',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h5" gutterBottom>
          Edit Profile
        </Typography>
        <Button
          variant="outlined"
          sx={{
            color: '#fff',
            backgroundColor: 'var(--pri-col)',
            borderColor: 'var(--pri-col)',
            textTransform: 'none',
            '&:hover': { backgroundColor: 'var(--pri-col)',borderColor:'var(--pri-col)' },
          }}
          onClick={() => editForm(false)}

        >
          Back to Profile
        </Button>
      </Box>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <IconButton
                component="label"
                sx={{
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  backgroundColor: "#f0f0f0",
                  border: "2px dashed #ccc",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                }}
              >
                {previewImage ? (
                  <Box
                    component="img"
                    src={previewImage}
                    alt="Profile Preview"
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Typography variant="h4" color="text.secondary">
                    +
                  </Typography>
                )}
                <input
                  type="file"
                  name="profileImage"
                  hidden
                  onChange={handleFileChange}
                />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="First Name"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Last Name"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              fullWidth
              required
              type="email"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Phone Number"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleInputChange}
              fullWidth
              required
              type="tel"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Country"
              name="countryId"
              value={formData.countryId}
              onChange={handleInputChange}
              fullWidth
              select
              required
            >
              {countries.map((country) => (
                <MenuItem key={country.id} value={country.id}>
                  {country.name} {/* Assuming country.name is the correct field */}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="City"
              name="cityId"
              value={formData.cityId}
              onChange={handleInputChange}
              fullWidth
              select
              required
            >
              {cities.map((city) => (
                <MenuItem key={city.id} value={city.id}>
                  {city.city} {/* Assuming city.name is the correct field */}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Identity Type"
              name="identityTypeId"
              value={formData.identityTypeId}
              onChange={handleInputChange}
              fullWidth
              select
              required
            >
              {identityTypes.map((type) => (
                <MenuItem key={type.id} value={type.id}>
                  {type.identity_type} {/* Assuming type.name is the correct field */}
                </MenuItem>
              ))}
            </TextField>
          </Grid>


          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <input
                type="file"
                name="identityImages"
                multiple
                onChange={handleFileChange}
                style={{
                  display: "none",
                }}
                id="upload-input"
              />
              <label htmlFor="upload-input">
                <Button variant="contained" sx={{
                  borderRadius: "5px",
                  backgroundColor: "#C47D60",
                  "&:hover": {
                    backgroundColor: "#a86850", // لون أغمق قليلاً عند التمرير
                  },
                }} component="span">
                  Upload Identity Images
                </Button>
              </label>
              <Typography variant="body2" color="text.secondary">
                {Files.identityImages?.length || 0} images selected
              </Typography>
            </Box>
          </Grid>


          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%", // لضمان محاذاة وسطية
              }}
            >
              <Button
                type="submit"
                variant="contained"
                sx={{
                  borderRadius: "5px",
                  backgroundColor: "#C47D60",
                  width: "50%",
                  "&:hover": {
                    backgroundColor: "#a86850", // لون أغمق قليلاً عند التمرير
                  },
                }}
              >
                Submit
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
      
    </Box>
  );
}

export default EditProfile;
